import axios from 'axios'
import { useEffect, useState } from 'react'
import { Get_OperatingSystems } from '../api/api'

const useOperatingSystems = () => {
  const [osOptions, setOsOptions] = useState([])

  useEffect(() => {
    const getOperatingSystems = async () => {
      try {
        const res = await axios.get(Get_OperatingSystems)
        setOsOptions(
          res.data.map((item) => ({
            value: item.id,
            label: item.title,
          }))
        )
      } catch (error) {
        setOsOptions([])
      }
    }
    getOperatingSystems()
  }, [])

  return osOptions
}

export default useOperatingSystems
